<template>
    <div class="type_document_unique-admin">
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input
                id="type_document_unique-id"
                type="hidden"
                v-model="type_document_unique.id"
            />
            <b-row>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="Descrição:"
                        label-for="type_document_unique-name_type_document_unique"
                    >
                        <b-form-input
                            id="type_document_unique-name_type_document_unique"
                            type="text"
                            v-model="type_document_unique.name_type_document_unique"
                            ref="searchFocus"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Descrição..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Reduzido:"
                        label-for="type_document_unique-initial_type_document_unique"
                    >
                        <b-form-input
                            id="type_document_unique-initial_type_document_unique"
                            type="text"
                            v-model="type_document_unique.initial_type_document_unique"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Reduzido..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="type_document_unique.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="type_document_unique-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="type_document_unique-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="type_document_unique.required"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="type_document_unique-required"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="type_document_unique-required"
                            >
                                Obrigatório?
                            </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="type_document_unique.has_date"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="type_document_unique-has_date"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="type_document_unique-register"
                            >
                                Exige Data de Validade?
                            </label>
                        </div>
                    </div>
                </b-col>
                  <b-col md="4" sm="12">
                    <b-form-group
                        label="Index:"
                        label-for="type_document_unique-index_order"
                    >
                        <b-form-input
                            id="type_document_unique-index_order"
                            type="text"
                            v-model="type_document_unique.index_order"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Index..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                 <b-col md="12" sm="12">
                    <b-form-textarea
                    id="type_document_unique-description_type_document_unique"
                    v-model="type_document_unique.description_type_document_unique"
                    placeholder="Detalhamento.."
                    rows="3"
                    max-rows="6"
                    :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                    ></b-form-textarea>
                 </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Url de Acesso:"
                        label-for="type_document_unique-url_type_document_unique"
                    >
                        <b-form-input
                            id="type_document_unique-url_type_document_unique"
                            type="text"
                            v-model="type_document_unique.url_type_document_unique"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Url de Acesso..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="8" sm="6">
                    <b-form-group
                        label="Arquivo Modelo:"
                        label-for="type_document-model_attach_id_type_document_unique"
                    >
                    <b-form-file
                        accept=".docx"
                        v-model="file"
                        class="mt-4 mb-4"
                        plain
                        @input="saveImagem"
                        size="sm"
                    ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
        <b-row>
            <b-col xs="12">
                <b-button
                    title="Adicionar"
                    size="sm"
                    class="mt-2 mb-2 fa fa-plus"
                    variant="dark"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                ></b-button>
                <b-button
                    title="Salvar"
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                ></b-button>
                <b-button
                    title="Excluir"
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                ></b-button>
                <b-button
                    title="Voltar"
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                ></b-button>
            </b-col>
        </b-row>
        <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <div class="col-sm-6">
                <b-form-group>
                    <input
                        size="lg"
                        type="text"
                        icon="search"
                        v-model="search"
                        placeholder="Informe a descrição"
                        class="form-control"
                    />
                </b-form-group>
            </div>
            <transition name="slide" type="animation" appear>
                <b-table
                    :busy="isBusy"
                    class="table-responsive"
                    hover
                    key="slide"
                    head-variant="light"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="filteredList"
                    :fields="fields"
                >
                    <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button
                            title="Editar"
                            size="sm"
                            variant="light"
                            @click="loadtype_document_unique(data.item)"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="rows"
            >
            </b-pagination>
        </b-row>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'TypeDocumentUniqueAdmin',

    data: function() {
        return {
            mode: 'insert',
            type_document_unique: {},
            type_document_uniques: [],
            search: '',
            showTable: false,
            showSearch: true,
            isBusy: false,
            currentPage: 1,
            perPage: 5,
            fields: [
                { key: 'id', label: 'Código', sortable: true },
                {
                    key: 'name_type_document_unique',
                    label: 'Descrição',
                    sortable: true
                },
                {
                    key: 'initial_type_document_unique',
                    label: 'Reduzido',
                    sortable: false
                },
                {
                    key: 'index_order',
                    label: 'Index',
                    sortable: false
                },
                {
                    key: 'required',
                    label: 'Obrig.',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'has_date',
                    label: 'Validade?',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'url_type_document_unique',
                    label: 'Url',
                    sortable: false
                },
                {
                    key: 'name_file',
                    label: 'Arquivo Modelo',
                    sortable: false
                },
                { key: 'actions', label: 'Ações', variant: 'secondary' }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        filteredList() {
            return this.type_document_uniques.filter(type_document_unique => {
                return type_document_unique.name_type_document_unique
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.type_document_uniques.length
        }
    },
    methods: {
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        loadTypeDocuments() {
            const url = `${baseApiUrl}/typedocumentuniques`
            axios.get(url).then(res => {
                this.type_document_uniques = res.data
                this.isBusy = false
            })
        },
        alterModo() {
            this.mode = 'save'
            this.type_document_unique = {}
            this.$refs.searchFocus.focus()
        },
        save() {
            const method = this.type_document_unique.id ? 'put' : 'post'
            const id = this.type_document_unique.id ? `/${this.type_document_unique.id}` : ''
            axios[method](
                `${baseApiUrl}/typedocumentuniques${id}`,
                this.type_document_unique
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        reset() {
            this.mode = 'insert'
            this.loadTypeDocuments()
        },
        remove() {
            const id = this.type_document_unique.id
            axios
                .delete(`${baseApiUrl}/typedocumentuniques/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadtype_document_unique(type_document_unique, mode = 'save') {
            this.mode = mode
            this.type_document_unique = { ...type_document_unique }
            this.$refs.searchFocus.focus()
        },
        async saveImagem() {
            let formData = new FormData()
            formData.append('file', this.file)
            formData.append('type_document_unique_id', this.type_document_unique.id)

            await axios
                .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.getLastStorageFile()
                })
                .catch(showError)
        },
        async getLastStorageFile() {

             const url = `${baseApiUrl}/storagefilestypedocumentuniquebylast/?name_file=${this.file.name}&type_document_unique_id=${this.type_document_unique.id}`
             await axios(url).then(
                 res => (
                    this.type_document_unique.model_attach_id_type_document_unique = res.data.id
                 )
             )

        }
    },
    mounted() {
        this.loadTypeDocuments()
        this.showTable = true
    }
}
</script>

<style>
.type_document_unique-admin select {
    font-size: 0.75rem;
}
.type_document_unique-admin input {
    font-size: 0.75rem;
}
.type_document_unique-admin button {
    font-size: 0.75rem;
}
.type_document_unique-admin table {
    font-size: 0.75rem;
}

.type_document_unique-admin textarea {
    font-size: 0.75rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
